import { Button, Input, Select } from "antd";
import { CaretDownFilled, CaretUpOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import GetPaymentMethods from "../../functions/reference/getPaymentMethods";
import { useAdmin } from "../../context/adminContext";

const SearchPaymentMethod = ({
  title,
  fieldName,
  search,
  query,
  width = 200,
}) => {
  const { searchFields, setSearchFields, showFilter } = useAdmin();
  const [selectData, setSelectData] = useState([
    { value: "ALL", title: "Сонго" },
  ]);
  useEffect(() => {
    fetchMethods();
  }, []);
  const fetchMethods = async () => {
    const data = await GetPaymentMethods();
    if (data)
      setSelectData([
        ...selectData,
        ...data.map((e) => ({ value: e.id, title: e.name })),
      ]);
  };
  const selectChange = (value) => {
    var query = { ...searchFields };

    if (value === selectData[0].value) delete query[fieldName];
    else query[fieldName] = value;
    setSearchFields(query);
  };
  const sortChange = (sort) => {
    setSearchFields({ ...searchFields, sort: sort, sortField: fieldName });
  };
  return (
    <div key={fieldName}>
      <div className="titleWithSort">
        <span style={{ fontSize: 12 }}>{title}</span>
        <div className="sortIcons">
          <CaretUpOutlined
            className="sortIcon"
            style={{ color: "#45a898" }}
            onClick={() => sortChange("asc")}
          />
          <CaretDownFilled
            className="sortIcon"
            style={{ color: "#45a898" }}
            onClick={() => sortChange("desc")}
          />
        </div>
      </div>
      {showFilter && (
        <>
          <div className="line" />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Select
              size="small"
              defaultValue={selectData[0].value}
              style={{ width: width }}
              onChange={selectChange}
            >
              {selectData.map((e, i) => {
                return (
                  <Select.Option key={i} value={e.value}>
                    {e.title}
                  </Select.Option>
                );
              })}
            </Select>
          </div>
        </>
      )}
    </div>
  );
};
export default SearchPaymentMethod;
